export default "/assets/images/homewrecker-circle.1197483a3c555903.png";